export const languages = [
  {
    id: "ar",
    textOption: "العربية",
    onClickHandler: () => {
      this.$i18n.locale = "ar";
      this.$store.dispatch("setLanguage", "ar");
    }
  },
  {
    id: "de",
    textOption: "Deutsch",
    onClickHandler: () => {
      this.$i18n.locale = "de";
      this.$store.dispatch("setLanguage", "de");
    }
  },
  {
    id: "en",
    textOption: "English",
    onClickHandler: () => {
      this.$i18n.locale = "en";
      this.$store.dispatch("setLanguage", "en");
    }
  },
  {
    id: "es",
    textOption: "Español",
    onClickHandler: () => {
      this.$i18n.locale = "es";
      this.$store.dispatch("setLanguage", "es");
    }
  },
  {
    id: "pt",
    textOption: "Português",
    onClickHandler: () => {
      this.$i18n.locale = "pt";
      this.$store.dispatch("setLanguage", "pt");
    }
  },
  {
    id: "fr",
    textOption: "Français",
    onClickHandler: () => {
      this.$i18n.locale = "fr";
      this.$store.dispatch("setLanguage", "fr");
    }
  },
  {
    id: "tl",
    textOption: "Tagalo(Filipino)",
    onClickHandler: () => {
      this.$i18n.locale = "tl";
      this.$store.dispatch("setLanguage", "tl");
    }
  },
  {
    id: "tr",
    textOption: "Türkçe",
    onClickHandler: () => {
      this.$i18n.locale = "tr";
      this.$store.dispatch("setLanguage", "tr");
    }
  }
];
